import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class CfmViewFormService {

  constructor(private http:HttpClient,private UTS: UtilitiesService) {}

sendCFM(surveyFormObject) {
  return this.http.post(environment.ECARE_URL + '/eshop/submitCFM', surveyFormObject);
}

getCFMData() {
  const lan =  this.UTS.getLocaleLanguage().toLocaleLowerCase();
  return this.http.get(environment.ECARE_URL + '/eshopApp/assets/offlineData/cfm/cfm-data-' + lan + '.json')
}

}
